import React from "react";
import "./GlobalQuickJump.css";

export function scrollToElementId(id) {
  const el = document.getElementById(id);
  el?.scrollIntoView({ behavior: "smooth", block: "start" });
}

/**
 * Sticky rail with buttons that scroll to section ids and highlight the active key.
 *
 * @param {string} [title="Quick jump"]
 * @param {{ key: string, label: string, targetId: string, group?: string }[]} items
 * @param {string | null} activeKey
 * @param {(key: string) => void} [onActiveChange]
 * @param {string} [asideAriaLabel]
 * @param {boolean} [scrollToTarget=true] When false, only `onActiveChange` runs (e.g. panel switching).
 */
export default function GlobalQuickJump({
  title = "Quick jump",
  items = [],
  activeKey = null,
  onActiveChange,
  asideAriaLabel = "Quick jump navigation",
  scrollToTarget = true
}) {
  return (
    <aside className="gqj-rail" aria-label={asideAriaLabel}>
      <div className="gqj-rail__block">
        <p className="gqj-rail__title">{title}</p>
        <div className="gqj-actions" role="group" aria-label={title}>
          {items.map((it, idx) => {
            const prevGroup = items[idx - 1]?.group;
            const showGroup = it.group && it.group !== prevGroup;
            return (
              <React.Fragment key={it.key}>
                {showGroup ? (
                  <p className="gqj-rail__group">{it.group}</p>
                ) : null}
                <button
                  type="button"
                  className={`gqj-actions__btn${
                    activeKey === it.key ? " gqj-actions__btn--active" : ""
                  }`}
                  onClick={() => {
                    onActiveChange?.(it.key);
                    if (scrollToTarget) scrollToElementId(it.targetId);
                  }}
                >
                  {it.label}
                </button>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </aside>
  );
}
